import axios from "axios"
import { AuthorsOrderBy, AuthorsService } from "../client"
const API_URL = import.meta.env.VITE_API_URL

/* Interfaces */
export interface AddAuthorProps {
  onClose: () => void
  isOpen: boolean
}

export interface AuthorProps {
  onClose: () => void
  isOpen: boolean
  authorId: string
}


/* Endpoints */
export const readAuthors = ({
    per_page,
    page,
    order_by,
    descending,
    query,
}: {
    per_page: number,
    page: number
    order_by?: AuthorsOrderBy
    descending?: boolean
    query?: string
}) => {

  return {
    queryFn: async () => {
      const data = await AuthorsService.readAuthors({
        skip: (page - 1) * per_page,
        limit: per_page,
        orderBy: order_by,
        descending: descending,
        query: query,
      })

      return data ?? { data: null, count: 0 }
    },
    queryKey: ["authors", { page, order_by, descending, query }],
  }
}

export const readAuthorsFieldAuthors = (query: string | null) => {
  return {
    queryFn: async () => {
      const data = await AuthorsService.readAuthors({query: query})
      return data ?? { data: [], count: 0 }
    },
    queryKey: ["authors", { query }],
  }
}

export const readAuthorById = (authorId: string) => {
  return {
    queryFn: async () => {
      const data =  await AuthorsService.readAuthorById({
        authorId: authorId,
      })
      return data ?? { data: null, count: 0 }
    },
    queryKey: ["author", { authorId }],
  }
}


export async function exportAuthors(params: {
  authorgroup_name?: string | null
  descending?: boolean
  order_by?: AuthorsOrderBy
  query?: string | null
}, showToast: any,) {
  try {
    let filename = "export_autoren.xlsx"

    const bearer = localStorage.getItem("access_token")

    const response = await axios.get(`${API_URL}/v1/reda/authors/export`, {
      responseType: "blob",
      params: params,
      headers: {
        Authorization:  `Bearer ${bearer}`
      }
    })

    if (response.status === 204) { 
      showToast( "Keine Daten", "Es sind keine Autoren zum Exportieren vorhanden.", "warning" )
      return
    }
    
    const blob = response.data
    const url = window.URL.createObjectURL(blob)
    var a = document.createElement("a")
    a.href = url
    a.download = filename
    document.body.appendChild(a)
    a.click()
    a.remove()

    showToast("Aktion erfolgreich!", "Die Datei wurde heruntergeladen", "success")
  } catch (error) {
    showToast("Fehler", "Die Datei konnte nicht heruntergeladen werden.", "error")
  }
}